import React, { useEffect, useState } from "react";
import SupportScreen from "./SupportScreen";
import SupportScreenMobile from "./SupportScreenMobile";

export default function ResponsiveSupportScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <SupportScreenMobile /> : <SupportScreen />;
}